import { type LucideIcon } from "lucide-react";

import { StandardPageLayout } from "@/components/layouts/standard-page-layout";
import { SettingsMobileNav, SettingsSidebar } from "./settings-sidebar";

interface SettingsPageLayoutProps {
  pageTitle?: {
    icon: LucideIcon;
    title: string;
    description: string;
    actions?: React.ReactNode;
  };
  children: React.ReactNode;
}

export function SettingsPageLayout({
  pageTitle,
  children,
}: SettingsPageLayoutProps) {
  return (
    <StandardPageLayout
      pageTitle={pageTitle}
      sidebar={<SettingsSidebar />}
      sidebarWidth="narrow"
    >
      <SettingsMobileNav />
      {children}
    </StandardPageLayout>
  );
}
